var PageDD = require('../../pageActionDropdown/view'),
    PartialTemplate = require('./partial.hbs');

module.exports = PageDD.extend({
    onAfterSwapEl: function() {
        var o = this.options;
        this.$el.append( PartialTemplate({
            hasImageOverlay: o.hasImageOverlay,
            showImgOverlay: o.hasImageOverlay && o.showImgOverlay,
            showGreenbar: o.showGreenbar
        }) );
    },
    ui: _.extend( {}, PageDD.prototype.ui, {
        overlayMi:          '.toggle-overlay',
        textSelectionMi:    '.toggle-text-selection',
        greenBarMi:         '.toggle-greenBar'
    }),
    /* textSelectionMi only applicable when in canvas edit mode --- will never occur on initial render */
    onCanvasEditModeToggled: function(entering) {
        this.ui.textSelectionMi.toggleClass('disabled', !entering);
        //ensure its not active when closing ... go back to default
        !entering && this.ui.textSelectionMi.removeClass('active'); //(active will override disabled in appearance)
    },
    events: function() {
        //var vCh = this.options.vChannel;
        var parent = this.options.parent;

        return _.extend( {}, PageDD.prototype.events.apply(this, arguments), {
            'click @ui.overlayMi': function(e) {
                var $target =  $(e.currentTarget); //TODO: common
                if ($target.hasClass('disabled')) return;
                $target.toggleClass('active');
                parent.triggerMethod('toggleOverlayImg');
            },
            'click @ui.textSelectionMi': function(e) {
                var $target =  $(e.currentTarget);
                if ($target.hasClass('disabled')) return;
                $target.toggleClass('active');
                parent.triggerMethod('toggleTextSelection');
            },
            'click @ui.greenBarMi': function(e) {
                var $target =  $(e.currentTarget);
                if ($target.hasClass('disabled')) return;
                $target.toggleClass('active');
                parent.triggerMethod('toggleGreenBar');
            }
        });
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/overlay/textPageDropdown/view.js
 ** module id = 471
 ** module chunks = 0
 **/